// ─── BLACKTOP TMS DESIGN TOKENS ──────────────────────────────────────────────

export const colors = {
  bg: '#050505',
  surface: '#0d0d0d',
  border: '#1e1e1e',
  accent: '#32CD32',
  accentDim: '#1a7a1a',
  text: '#e0e0e0',
  textDim: '#777',
  red: '#FF4444',
  yellow: '#FFD700',
  green: '#32CD32',
  blue: '#4488FF',
};

export const card: React.CSSProperties = {
  background: colors.surface,
  border: `1px solid ${colors.border}`,
  borderRadius: '4px',
  padding: '24px',
  marginBottom: '16px',
};

export const table: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontFamily: 'monospace',
  fontSize: '12px',
};

export const th: React.CSSProperties = {
  background: '#0a0a0a',
  color: colors.accent,
  fontWeight: 700,
  letterSpacing: '1px',
  fontSize: '10px',
  padding: '10px 12px',
  textAlign: 'left',
  borderBottom: `1px solid ${colors.border}`,
};

export const td: React.CSSProperties = {
  padding: '10px 12px',
  borderBottom: `1px solid ${colors.border}`,
  color: colors.text,
  verticalAlign: 'middle',
};

export const input: React.CSSProperties = {
  background: '#0a0a0a',
  border: `1px solid ${colors.border}`,
  color: colors.text,
  padding: '8px 12px',
  fontFamily: 'monospace',
  fontSize: '13px',
  width: '100%',
  boxSizing: 'border-box',
  outline: 'none',
};

export const btn: React.CSSProperties = {
  background: colors.accent,
  color: '#000',
  border: 'none',
  padding: '10px 20px',
  fontFamily: 'monospace',
  fontWeight: 700,
  fontSize: '12px',
  letterSpacing: '1px',
  cursor: 'pointer',
};

export const btnOutline: React.CSSProperties = {
  background: 'transparent',
  color: colors.accent,
  border: `1px solid ${colors.accent}`,
  padding: '8px 16px',
  fontFamily: 'monospace',
  fontWeight: 700,
  fontSize: '11px',
  letterSpacing: '1px',
  cursor: 'pointer',
};

export const sectionHeader: React.CSSProperties = {
  color: colors.accent,
  marginTop: 0,
  fontSize: '10px',
  letterSpacing: '2px',
  fontWeight: 700,
  borderBottom: `1px solid ${colors.border}`,
  paddingBottom: '8px',
  marginBottom: '14px',
};

export const fieldRow: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '6px 0',
  borderBottom: `1px solid #111`,
  margin: 0,
};

export const fieldLabel: React.CSSProperties = {
  color: colors.textDim,
  fontSize: '10px',
  letterSpacing: '1px',
  fontWeight: 700,
};

export const fieldVal: React.CSSProperties = {
  color: colors.text,
  fontSize: '13px',
  fontWeight: 500,
};

export const bandColor = (band: string) => {
  if (band === 'RED') return colors.red;
  if (band === 'YELLOW') return colors.yellow;
  return colors.green;
};

export const statusColor = (status: string) => {
  if (status === 'DELIVERED') return colors.green;
  if (status === 'IN TRANSIT') return colors.blue;
  if (status === 'CANCELLED') return colors.red;
  if (status === 'ACTIVE') return colors.yellow;
  return colors.textDim;
};

export const complianceColor = (dateStr: string | null) => {
  if (!dateStr) return colors.textDim;
  const exp = new Date(dateStr);
  const now = new Date();
  const days = (exp.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
  if (days < 0) return colors.red;
  if (days < 30) return colors.yellow;
  return colors.green;
};

export const complianceLabel = (dateStr: string | null) => {
  if (!dateStr) return '---';
  const exp = new Date(dateStr);
  const now = new Date();
  const days = Math.round((exp.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  if (days < 0) return `EXPIRED ${Math.abs(days)}d ago`;
  if (days < 30) return `${dateStr} (${days}d left)`;
  return dateStr;
};
